import { UPDATE_THD_STORE_INFO } from './actionTypes';

export default (thdStoreInfo, isMajorAppliance) => ({
  type: UPDATE_THD_STORE_INFO,
  thdStoreInfo,
  isMajorAppliance,
});
